export const WALKTHROUGH_Z_INDEX = {
	// Below the MUI modal/popover layer (1300) so dropdowns stay above the dim; above the side panel (1200).
	dim: 1290,
	ring: 1350,
	card: 1360
} as const;
